import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { BsPencilSquare } from "react-icons/bs";
import { useState, useEffect } from "react";

const EditRefereeModal = ({
  visible,
  close,
  referee,
  onUpdate,
  loading = false
}) => {
  const [editName, setEditName] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    if (referee) {
      setEditName(referee.refereeName || "");
      setEditEmail(referee.refereeEmail || "");
    }
  }, [referee]);

  const validateName = (name) => {
    const tokens = name.trim().split(/\s+/).filter(token => token.length > 0);
    if (tokens.length < 2) {
      setNameError("Name must include both first and last name");
      return false;
    }
    setNameError("");
    return true;
  };

  const handleUpdate = () => {
    if (validateName(editName) && editName.trim() && editEmail.trim()) {
      onUpdate(editName.trim(), editEmail.trim());
    }
  };

  const handleClose = () => {
    setEditName("");
    setEditEmail("");
    setNameError("");
    close();
  };

  return (
    <Modal show={visible} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className="text-capitalize">
          <h1 className="text-axis-offblack icon-text-wrapper">
            <BsPencilSquare className="icon-right-spacing" />
            Edit Reference Details
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Reference Name</Form.Label>
            <Form.Control
              type="text"
              value={editName}
              onChange={(e) => {
                setEditName(e.target.value);
                if (e.target.value.trim()) {
                  validateName(e.target.value);
                }
              }}
              placeholder="Enter referee name"
              disabled={loading}
              isInvalid={!!nameError}
            />
            {nameError && (
              <Form.Control.Feedback type="invalid">
                {nameError}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group>
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              value={editEmail}
              onChange={(e) => setEditEmail(e.target.value)}
              placeholder="Enter email address"
              disabled={loading}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={handleClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={handleUpdate}
          disabled={loading || !editName.trim() || !editEmail.trim() || !!nameError}
        >
          {loading ? "Updating..." : "Update Details"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditRefereeModal;